import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {CustomerInteraction} from "../model/customerInteraction";

@Injectable({
  providedIn: 'root'
})
export class CustomerInteractionService {

  constructor(private httpClient: HttpClient) { }

  getCustomerInteractionById(id,options={}){
    return this.httpClient.get("/api/customer-interactions/" + id, options);
  }

  getCustomerInteractions(options = {}): Observable<CustomerInteraction[]> {
    return this.httpClient.get<CustomerInteraction[]>("/api/customer-interactions", options);
  }

  uploadAuthorities(files,id,propertyId){
    const formData: FormData = new FormData();

    files.forEach(f => {
      formData.append("files",f)
    })

    const req = new HttpRequest('POST', "/api/properties/" + propertyId + "/customer-interactions/" + id + "/authorities", formData, {
      responseType: 'json',
      withCredentials: true,
      headers: new HttpHeaders({'showing-spinner': ''})
    });

    return this.httpClient.request(req)
  }

  /**
   * Adds a free text response to a specific customer interaction for a specific property
   *
   * @param propertyId Id of the property the customer interaction is part of
   * @param id Id of the customer interaction to which the response should be added
   * @param textResponse Text the user want to set into the response
  */
  public uploadFreeTextResponse(propertyId: string, id: string, textResponse: string){
    return this.httpClient.post("/api/properties/" + propertyId + "/customer-interactions/" + id + "/free-text", textResponse, {headers: new HttpHeaders({'showing-spinner': ''})});
  }

  /**
   * Adds a customer interaction as a user for a specific property
   *
   * @param propertyId ID of the property to which the customer interaction should be added
   * @param textResponse Text the user wants to set into the customer interaction
   * @param associatedIds Ids of the documents the customer interaction refers to. Empty if it is a general request
  */
  public addUserCustomerInteraction(propertyId: string, textResponse: string, associatedIds: string[]): Observable<CustomerInteraction>{
    return this.httpClient.post<CustomerInteraction>("/api/properties/" + propertyId + "/customer-interactions", {message: textResponse, associatedIds: associatedIds}, {headers: new HttpHeaders({'showing-spinner': ''})});
  }
}
